import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step1 } from '../../../../shared/models/component-messages/blocCommun/divers/step1';
import { TypeOuiNon } from '../models/TypeOuiNon';
@Component({
  selector: 'app-type-oui-non',
  templateUrl: './type-oui-non.component.html'
})
export class TypeOuiNonComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeOuiNon';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
  	@Input() variantes: TypeOuiNon;

    public step1 = new Step1();

    radioButtonValue;
    radioButtonCtrlName;
    oui = 'oui';
    non = 'non';
  constructor() { }

  public ngOnInit() {
    if (this.variantes?.oui){
      this.radioButtonValue = this.oui;
    } else {
      this.radioButtonValue = this.non;
    }

    this.radioButtonCtrlName = this.getUid() + '_SepAtt_oui';
  }
  
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
  
}

